export default "__VITE_ASSET__7d1217fe__"